import React, { useState, useEffect, useRef } from "react";
import Table from "../../Common/table";
import axios from "../../httpServices/httpService";
import api from "../../config.json";
import swal from "sweetalert";
import auth from "../../httpServices/authService";
import validation from "../../utill/validation";
import _, { cloneDeep, result } from "lodash";
import joi, { object } from "joi";
import Loading from "../../utill/LoadingComponent";
import date from "../../utill/dateTime";
// import EquipmentSelection from '../Common/equipmentSelection';
import { ToastContainer, toast } from "react-toastify";
import DateSelection from "../../Common/DateSelection";
import { Button, Modal, Select } from "antd";
// import 'antd/dist/antd.css';
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFile,
  faFilePdf,
  faMinusCircle,
  faPlusCircle,
  faThumbsDown,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import ExportPdfButton from "../../utill/ExportPdf";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Tooltip from "../../utill/tooltip";
import PaginationComponent from "../../Common/PaginationComponent";
import { generateExcelFile } from "../../utill/download";

const MaterialAvailabilityreport = ({
  handleDownloadTableToExcel,
  equips,
  equipGroups,
  fromDateLimit,
  Heading,
}) => {
  const reportType = [
    // { label: "Incoming Inspection", value: "Incoming", name: "IncomingInspection" },
    // { label: "First Part Inspection", value: "FirstPart", name: "FirstPartInspection" },
    // { label: "Inprocess Inspection", value: "Inprocess", name: "InProcessInspection" },
    // { label: "Last Part Inspection ", value: "LastPart", name: "LastPartInspection" },
    // { label: "FinishedGoods Inspection", value: "FinishedGoods", name: 'FG_Inspection' }
  ];
  const [qualityData, setQualityData] = useState([]);
  const [inputData, setInputData] = useState({
    From: new Date(),
    Till: new Date(),
  });
  const [CompoundCodeList, setCompoundCodeList] = useState([]);
  const [allTypeCache, setAllTypeCache] = useState([]);
  const [BatchCodeList, setBatchCodeList] = useState([]);

  const [sortColumn, setSortColumn] = useState({
    path: "ToolId",
    order: "asc",
  });
  const [open, setOpen] = useState(false);
  const [pdfOpen, setPdfOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalPage, setTotalPage] = useState(0);
  const [PageSize, setPageSize] = useState(50);

  const customerRef = useRef(null);
  // const filteredOptions = clients.filter((o) => !selectedItems.find(b => o.label == b));

  useEffect(() => {
    Heading("Material Availability Report");
    GetAllInspetcionTypes();
  }, []);
  useEffect(() => {
    handleGetData();
  }, [CurrentPage, PageSize]);

  const handleOnChange = (name, value) => {
    const obj = { ...inputData };
    obj[name] = value;
    setInputData(obj);
    if (name === "CompoundCode") {
      handelgetBatchCodeList(obj);
    } else if (name === "From" || name === "Till") {
      if (obj['CompoundCode'] && obj['CompoundCode'].length > 0) {
        handelgetBatchCodeList(obj);
      }
    }
  };

  const handleGetData = async () => {
    // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
    setLoader(true);
    axios
      .post(api.api + "MaterialAvailable", inputData
        //      {
        //     query: inputData,
        //     PageSize: PageSize,
        //     Page: CurrentPage,
        //   }
      )
      .then((result) => {
        setLoader(false);

        setQualityData(result.data);
        // setTotalPage(result.data.totalDocument);
      })

      .catch((err) => {
        setLoader(false);
      });
  };
  const handelgetBatchCodeList = async (value) => {
    // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
    setLoader(true);
    axios
      .put(api.api + "FetchBatchCodes", value)
      .then((result) => {
        const batchCodeList = [];
        // result.data = [...new Set(result.data.map(str => str.trim()))];
        result.data.forEach((one) => {
          const obj = {
            label: one,
            value: one,
            name: one,
          };
          batchCodeList.push(obj);
        });
        setBatchCodeList(batchCodeList);
        setLoader(false);
      })

      .catch((err) => {
        setLoader(false);
      });
  };

  const handleSort = (sortColumn) => {
    if (qualityData.length > 0) {
      const sorted = _.orderBy(
        qualityData,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);
      setQualityData(sorted);
    }
  };






  const columns1 = [
    // {
    //   path: "DateTime",
    //   label: "Date",
    //   content: (obj) => <>{moment(obj.DateTime).format("DD-MM-YY")}</>,
    // },
    // {
    //   path: "DateTime",
    //   label: "Time",
    //   content: (obj) => <>{moment(obj.DateTime).format("hh:mm a")}</>,
    // },
    { path: "CompoundCode", label: "Compound Code" },
    { path: "BatchCode", label: "Batch Code" },
    {
      path: "Kneaded", label: "Kneaded / Available (kg)",
      content: (obj) => (
        <div

        >
          {obj.Kneaded} / {(obj.Kneaded - obj.Activated)}
        </div>
      ),
    },
    {
      path: "Activated", label: "Activated / Available (kg)",
      content: (obj) => (
        <div

        >
          {obj.Activated ?? 0} / {obj.Available ?? 0}

        </div>
      ),
    },



    {
      path: "Issued",
      label: "Issued",
      content: (obj) => (
        <div

        >
          {obj.Issued ?? 0}
        </div>
      ),
    },

    // {
    //     key: "view",
    //     label: "View Report",
    //     content: (obj) => (
    //         <React.Fragment>
    //             <button className='btn btn-secondary' onClick={() => {
    //                 const part = allPartsCache.find((part) => part.ItemName == obj.BatchCode && part.ItemNumber == obj.ItemNumber )
    //                 if (part) {
    //                     const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
    //                     const template = checkPointTemplates.find(x => checkSheet && checkSheet.checkSheetTitle && x.Name == checkSheet.checkSheetTitle.TemplateName)
    //                     template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
    //                     setSelectedTemplate(template)
    //                 }
    //                 setReportData(obj);
    //                 setOpen(true)
    //             }}>
    //                 <FontAwesomeIcon icon={faFile} />
    //             </button>
    //         </React.Fragment>
    //     ),
    // },
    // {
    //     key: "PDF View",
    //     label: "View PDF",
    //     content: (obj) => (
    //         <React.Fragment>
    //             {
    //                 reportTypes.filter(item => item == obj.InspectionType).length > 0 ? <button className='btn btn-secondary' onClick={() => {
    //                     const part = allPartsCache.find((part) => part.ItemName == obj.BatchCode && part.ItemNumber == obj.ItemNumber )
    //                     if (part) {
    //                         const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
    //                         const template = checkPointTemplates.find(x => checkSheet.checkSheetTitle && x.Name == checkSheet.checkSheetTitle.TemplateName)
    //                         template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
    //                         setSelectedTemplate(template)
    //                         const shift = obj.customFields.find(x => x && x.FieldName == "Shift")
    //                         const batchCode = obj.customFields.find(x => x && x.FieldName == "Batch Code")
    //                         const machine = obj.customFields.find(x => x && x.FieldName == "Machine")
    //                         if (obj.InspectionType == "Poka - Yoke Sheet") {
    //                             const currentDate = new Date();
    //                             const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    //                             handleGetPdfData({ InspectionType: obj.InspectionType, ItemName: obj.BatchCode, ItemNumber: obj.ItemNumber,
    //                                 //  Operation: obj.Operation,
    //                                   From: startOfMonth, Till: currentDate, Shift: shift ? shift.Value : "" })
    //                         } else {
    //                             handleGetPdfData({ InspectionType: obj.InspectionType, ItemName: obj.BatchCode, ItemNumber: obj.ItemNumber,
    //                                 //  Operation: obj.Operation,
    //                                   From: obj.DateTime, Till: obj.DateTime, Machine: machine, BatchCode: batchCode, Shift: shift ? shift.Value : "" })
    //                         }
    //                     }
    //                     setReportData(obj);
    //                     setPdfOpen(true)
    //                 }}>
    //                     <FontAwesomeIcon icon={faFilePdf} />
    //                 </button>
    //                     : <Tooltip text="Report Unavailable">
    //                         <button className='btn btn-secondary' disabled={true}>
    //                             <FontAwesomeIcon icon={faFilePdf} />

    //                         </button>
    //                     </Tooltip>}

    //         </React.Fragment>
    //     ),
    // },
  ];

  const GetAllInspetcionTypes = () => {
    axios
      .get(api.api + "compoundMaster")
      .then((result) => {
        const reports = [...reportType];
        result.data.forEach((one) => {
          const obj = {
            label: one.CompoundCode,
            value: one.CompoundCode,
            name: one.CompoundCode,
          };
          reports.push(obj);
        });
        setAllTypeCache(result.data);
        setCompoundCodeList(reports);
      })
      .catch((err) => { });
  };
  const handleDownloadExcel = (e) => {
    generateExcelFile(e);
  };

  return (
    <React.Fragment>
      {loader ? <Loading labelShow={true} label={"Loading..."} /> : ""}
      {/* <div className='text-center' >
                <p >QMS Report</p>
            </div> */}

      {/* <ToastContainer /> */}

      <div className="row">
        <div className="col-sm-2">
          <div className="form-group">
            <label className="small m-0"> Batch Generated From</label>
            <input
              value={moment(inputData.From).format("YYYY-MM-DD")}
              className="form-control form-control-sm"
              onChange={(e) => handleOnChange("From", e.currentTarget.value)}
              type="date"
            />
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <label className="small m-0">Batch Generated Till</label>
            <input
              value={moment(inputData.Till).format("YYYY-MM-DD")}
              className="form-control form-control-sm"
              onChange={(e) => handleOnChange("Till", e.currentTarget.value)}
              type="date"
            />
          </div>
        </div>
        <div className="col-sm-2">
          <label className="small text-center m-0">Compound Code</label>
          <Select
            maxTagCount={"responsive"}
            mode="multiple"
            placeholder="Select Compound Code"
            value={inputData.CompoundCode}
            onChange={(values) => {
              if (values.includes("All")) {
                if (inputData.CompoundCode && inputData.CompoundCode.length === CompoundCodeList.length) {
                  handleOnChange("CompoundCode", []);
                } else {
                  handleOnChange("CompoundCode", ["All"]);
                }
              } else {
                // Update selected values normally
                handleOnChange("CompoundCode", values);
              }
            }}
            style={{ width: "100%" }}
            options={[{ label: "All", value: "All" }, ...CompoundCodeList]}
          />
        </div>
        <div className="col-sm-2">
          <label className='small text-center m-0'>Batch Code</label>
          <Select
            maxTagCount={"responsive"}
            mode="multiple"
            placeholder="Select Batch Code"
            value={inputData.BatchCode}
            onChange={(values) => {
              if (values.includes('All')) {
                if (inputData.BatchCode && (inputData.BatchCode.length === BatchCodeList.length)) {
                  // Deselect all if "Select All" was deselected
                  handleOnChange('BatchCode', []);
                } else {
                  // Select all
                  handleOnChange('BatchCode', ["All"]);
                }
              } else {
                // Update selected values normally
                handleOnChange('BatchCode', values);
              }
            }}
            style={{ width: '100%' }}
            options={BatchCodeList.length == 0 ? [] : [
              { label: 'All', value: 'All' },
              ..._.uniqBy(BatchCodeList, "value")
            ]}
          />
          {/* <div className="form-group form-group-sm d-flex flex-column">
            <label htmlFor="operationRejectionCost " className="small m-0 ">
              Batch Code
            </label>
            <input
              required
              onChange={(e) =>
                handleOnChange("BatchCode", e.currentTarget.value)
              }
              className="form-control form-control-sm w-100 m-0 "
              style={{ backgroundColor: "white" }}
              type="text"
              name={"BatchCode"}
              value={inputData.BatchCode || ""}
              placeholder={"Enter BatchCode "}
            />
            {errors.BatchCode && (
                  <div className="alert small alert-danger">
                    {errors['BatchCode']}
                  </div>
                )}
          </div> */}
        </div>

        <div className="col-sm-1">
          <button
            className="btn btn-primary btn-sm mt-4"
            onClick={() => handleGetData()}
          >
            Apply
          </button>
        </div>
        {qualityData && qualityData.length > 0 ? (
          <div className="col-sm-2 py-4">
            <button
              onClick={() => handleDownloadExcel("MaterialAvailabilityReport")}
              className="btn-sm btn-primary "
            >
              Download Report
            </button>
          </div>
        ) : (
          ""
        )}
        <Modal
          // title={<strong>Report    <button className="btn-sm btn-primary" onClick={demoFromHTML}>Download PDF</button></strong>}
          centered
          open={open}
          // onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
          footer={[]}
          width={"95%"}
        ></Modal>
      </div>

      <Modal
        title=""
        centered
        open={pdfOpen}
        // onOk={() => setPdfOpen(false)}
        onCancel={() => setPdfOpen(false)}
        width={"95%"}
        footer={[]}
      >
        {/* <button className="btn-sm btn-primary" onClick={demoFromHTML}>Download PDF</button> */}
        <div id="customers" ref={customerRef} className="p-1  w-100">
          {/* {reports[reportData.InspectionType]} */}
          {/* <ProcessProductPatrolInspection item={allPartsCache.find(x => x.ItemName == inputData.ItemName)} company={company} data={reportData} pdfData={pdfData} /> */}
        </div>
      </Modal>



      {qualityData.length > 0 ? (
        <Table
          id="MaterialAvailabilityReport"
          onSort={handleSort}
          columns={columns1}
          sortColumn={sortColumn}
          // data={extractInspectionDataSeparateArray(qualityData[0])}
          //   searchquery={true}
          //   handelSearch={handleGetData1}
          data={qualityData}
        />
      ) : (
        <Table
          id="MaterialAvailabilityReport1"
          onSort={handleSort}
          columns={columns1}
          sortColumn={sortColumn}
          // data={extractInspectionDataSeparateArray(qualityData[0])}
          //   searchquery={true}
          //   handelSearch={handleGetData1}
          data={[]}
        />
      )}
      {/* {qualityData.length > 0 && (
        <div className="float-end m-3">
          <PaginationComponent
            defaultCurrent={CurrentPage}
            total={TotalPage}
            CurrentPageNumber={(currentpage, pagesize) => {
              setCurrentPage(currentpage);
              setPageSize(pagesize);
            }}
          />
        </div>
      )} */}
    </React.Fragment>
  );
};
export default MaterialAvailabilityreport;
